import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { hasPermission } from "../utils/permissions";

export default function PosProtectedRoute({ children }) {
  const location = useLocation();
  const { isLoading, isAuthenticated, user } = useAuth();

  if (isLoading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="h-10 w-10 rounded-full border-4 border-primary-100 border-t-primary-800 animate-spin" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return (
      <Navigate
        to="/pos/login"
        replace
        state={{ from: location.pathname }}
      />
    );
  }

  if (!hasPermission(user, "pos.view")) {
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
}